<ion-button expand="block" class="apple-button mb-3" (click)="login()">
    <ion-icon slot="start" name="logo-apple"></ion-icon>
    Sign in with Apple
</ion-button>
